<template>
  <j-modal
    :visible.sync="visible"
    :width="'90%'"
    @cancel="close()"
    :maskClosable="true"
    :destroyOnClose="false"
    :footer="null"
  >
    <h3 style="display: inline-block;" v-if="unitInfo">{{unitInfo.unitName}} 学员({{ studentList.length }})</h3>
    <span style="display: inline-block;">
        <!-- <a-button @click="selectAll" size="small">全选</a-button>
        <a-divider type="vertical"></a-divider>
        <a-button @click="cancelSelectAll" size="small">全不选</a-button>
        <a-divider type="vertical"></a-divider> -->
        <a-button @click="handleBatchSign" size="small">批量签到 ({{ studentList.length - signList.length }})</a-button>
        <a-divider type="vertical"></a-divider>
        <a-input size="small" addonBefore="本节消耗课时" v-model="courseHours" min="0" type="number" style="width: 180px"></a-input>
        <a-divider type="vertical"></a-divider>
        <a-button @click="handleBatchSetCommunityEnable(false)" size="small">关闭社区</a-button>
        <a-button @click="handleBatchSetCommunityEnable(true)" size="small">开启社区</a-button>
    </span>
    <a-divider></a-divider>
    <a-spin v-if="loading">加载中……</a-spin>
    <a-row type="flex" :gutter="[40, 10]">
      <a-col flex="500px" v-for="(s, i) in studentList" :key="i">
        <span
          >{{ s.username }} | {{ s.realname }} | {{ s.integral
          }}{{ $store.getters.tenantInfo.coinName }}</span
        >
        <span style="float: right">
          <a-popconfirm v-if="signList.includes(s.id)" title="确定取消签到吗?" @confirm="() => handleCancelSign(s.id)">
            <a-button icon="check" type="danger" size="small">已出勤</a-button>
          </a-popconfirm>
          <a-button v-else icon="check" type="primary" size="small" @click="handleSign(s.id)">签到</a-button>
          <a-divider type="vertical"></a-divider>
          <a-tooltip :title="$store.getters.tenantInfo.coinName + '操作'">
          <a  @click="handleIntegral(s.id)"><a-icon type="dollar" /></a>
          </a-tooltip>
          <a-divider type="vertical"></a-divider>
          <a-popover trigger="click">
            <template slot="content">
              <p>使用手机扫描进行课堂评价</p>
              <qrcode :value="getReviewUrl(s.id)" :size="250"></qrcode>
            </template>
            <a><a-icon type="camera"/></a>
          </a-popover>
          <a-divider type="vertical"></a-divider>
          <a-tooltip v-if="s.enableCommunity" title="该学生社区已开启，点击关闭">
            <a @click="handleSetCommunityEnable(s.id, false)"><a-icon type="eye"/></a>
          </a-tooltip>
          <a-tooltip v-if="!s.enableCommunity" title="该学生社区已关闭，点击开启">
            <a @click="handleSetCommunityEnable(s.id, true)"><a-icon type="eye-invisible"/></a>
          </a-tooltip>
        </span>
      </a-col>
    </a-row>
    <!-- 积分操作modal -->
    <sys-user-integral-modal
      ref="integralModal"
      @ok="integralModalFormOk"
    ></sys-user-integral-modal>
  </j-modal>
</template>

<script>
import Vue from 'vue'
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import SysUserIntegralModal from "@/components/user/SysUserIntegralModal";
import QrCode from '@/components/tools/QrCode'
export default {
  name: "ClassStudentListModal",
  components: {
    SysUserIntegralModal,
    qrcode: QrCode,
  },
  data() {
    return {
      visible: false,
      loading: false,
      departId: "",
      courseId: "",
      unitId: "",
      unitInfo: null,
      courseHours: undefined,
      studentList: [],
      signList: [],
      checkedList: [],
      url:{
        reviewUrl: window._CONFIG['webURL'] + '/teacherPhotoReview',
      }
    };
  },
  watch:{
    signList:{
      immediate: false,
      deep: true,
        handler() {
          this.handleSignListChange()
        }
    }
  },
  created() {
    
  },
  methods: {
    show(departId, courseId, unitId) {
      this.studentList = []
      // this.signList = []
      this.visible = true;
      this.departId = departId;
      this.courseId = courseId;
      this.unitId = unitId;
      this.getDepartStudent();
      if(!this.unitInfo){
        this.getUnitInfo()
      }
      // this.getClassroomSignList();
    },
    getUnitInfo(){
        getAction("/teaching/teachingCourseUnit/queryById", {id: this.unitId}).then(res=>{
          if(res.success){
            this.unitInfo = res.result
            if(this.unitInfo.courseHour){
              this.courseHours = this.unitInfo.courseHour
            }
          }
        })
    },
    getDepartStudent() {
      this.loading = true;
      getAction("/sys/user/departUserList", {
        depId: this.departId,
        userIdentity: 1,
        pageSize: 1000,
      })
        .then((res) => {
          if (res.success) {
            this.studentList = res.result.records;
          } else {
            this.$message.info(res.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getClassroomSignList() {
      this.signList = []
      getAction("/teaching/teachingStudyLog/classroomSignList", {
        departId: this.departId,
        courseId: this.courseId,
        unitId: this.unitId,
      })
        .then((res) => {
          if (res.success) {3
            for(let i=0; i<res.result.length; i++){
                this.signList.push(res.result[i].userId)
            }
          } else {
            this.$message.info(res.message);
          }
        })
        .finally(() => {
        });
    },
    selectAll(){

    },
    cancelSelectAll(){

    },
    handleBatchSign(){
        if(this.studentList.length == this.signList.length){
            this.$message.info('没有可以签到的学生')
            return
        }
        if(!this.courseHours){
          this.$message.error('请输入消耗课时')
          return
        }
        for(let i=0; i < this.studentList.length; i++){
            let stuId = this.studentList[i].id
            if(this.signList.includes(stuId)) continue;
            this.handleSign(stuId)
        }
    },
    handleSign(userId) {
      if(!this.courseHours){
        this.$message.error('请输入消耗课时')
        return
      }
      getAction("/teaching/teachingStudyLog/classroomSignByTeacher", {
        userId: userId,
        departId: this.departId,
        courseId: this.courseId,
        unitId: this.unitId,
        courseHours: this.courseHours
      }).then((res) => {
        if(res.success){
            this.signList.push(userId)
        }
        this.$message.info(res.message);
      });
    },
    handleCancelSign(userId) {
      getAction("/teaching/teachingStudyLog/classroomCancelSignByTeacher", {
        userId: userId,
        departId: this.departId,
        courseId: this.courseId,
        unitId: this.unitId,
      }).then((res) => {
        if(res.success){
            this.signList = this.signList.filter(item => item != userId)
        }
        this.$message.info(res.message);
      });
    },
    handleIntegral(userId) {
      this.$refs.integralModal.edit({ userId: userId, unitId: this.unitId });
    },
    integralModalFormOk() {
      this.getDepartStudent();
    },
    handleSignListChange(){
      console.log("handleSignListChange", this.signList);
      this.$emit('signListChange', this.signList)
    },
    getReviewUrl(userId){
      let token = Vue.ls.get(ACCESS_TOKEN);
      return `${this.url.reviewUrl}?departId=${this.departId}&courseId=${this.courseId}&userId=${userId}&unitId=${this.unitId}&token=${token}`
    },
    handleSetCommunityEnable(userId, enable, silent){
      getAction("/sys/user/setCommunityEnable", {userId, enable}).then(res=>{
        if(res.success){
          if(!silent){
            this.$message.success(res.message)
          }
          for(let i=0; i < this.studentList.length; i++){
            if(this.studentList[i].id == userId){
              this.studentList[i].enableCommunity = enable
            }
          }
        }
      })
    },
    handleBatchSetCommunityEnable(enable){
      if(this.studentList.length == 0){
          this.$message.info('没有可以操作的学生')
          return
      }
      for(let i=0; i < this.studentList.length; i++){
          let stuId = this.studentList[i].id
          if(this.signList.includes(stuId)) continue;
          this.handleSetCommunityEnable(stuId, enable, true)
      }
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style></style>